import { ChangeEvent, useCallback, useState } from 'react'
import type { IReferral } from '@sales-center/common'
import type { ILeadDetail } from '@user/store/lead'
import type { IOpportunityDetail } from '@user/store/opportunity'
import type { ENTITY_TYPES } from '@sales-center/common'
import type { LEAD_STATUSES } from '@user/components/Leads/LeadCard/typings'
import type { OPPORTUNITY_STATUSES } from '@user/components/Opportunities/OpportunityCard/typings'
import type { UpdateReferralInput } from '@user/components/DetailPages/sections/AdditionalInformation/hooks/typing'
import { useTheme } from '@mui/material/styles'
interface Props {
  detail: ILeadDetail | IOpportunityDetail
  entityId: number
  entityType: ENTITY_TYPES
  leadStatus?: LEAD_STATUSES
  opportunityStatus?: OPPORTUNITY_STATUSES
  canUpdate: boolean
  salesTeamId: string
  entityMatched: boolean
  execute: (refferalInput: UpdateReferralInput) => void
}

export function useHandlers(props: Props) {
  const [tabIndex, setTabIndex] = useState(0)
  const [showEmpty, setShowEmpty] = useState(false)
  const theme = useTheme()
  const handleReferralUpdate = useCallback(
    (referral: IReferral) => {
      props.execute({
        entityId: props.entityId,
        entityType: props.entityType,
        referral: referral,
      })
    },
    [props.execute, props.entityId, props.entityType],
  )

  const setColor = useCallback(
    (index: number) =>
      index === tabIndex ? '#19305A' : theme.palette.text.secondary,
    [tabIndex],
  )

  const handleChange = useCallback(
    (_, newTabIndex: number) => setTabIndex(newTabIndex),
    [],
  )

  const toggleShowEmpty = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setShowEmpty(event.target.checked)
    },
    [setShowEmpty],
  )

  return {
    handleReferralUpdate,
    setColor,
    handleChange,
    tabIndex,
    setTabIndex,
    toggleShowEmpty,
    showEmpty,
    setShowEmpty,
  }
}
